import axios from 'axios';

export class ServiceBase {
    protected http = axios.create({
      
      // Replace this baseURL with a local url
      baseURL: 'http://localhost:8000',

      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
